import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { SystemServiceService } from 'src/app/services/system-service.service';
import { Router, NavigationEnd } from '@angular/router';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/shared/redux/loading.actions';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

	public nombreUsuario: string = '';
	private subscription: Subscription
	private urlSubscription: Subscription
	public subModules: any[] = []
	public homeLink: string = '/home';
	public parentModule: string = null;
	constructor(
		private store: Store<AppState>,
		private systemService: SystemServiceService,
		private router: Router
	) {
		this.nombreUsuario = <string>JSON.parse(sessionStorage.getItem('nombreUsuario'));
		this.urlSubscription = this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				let ruta = event.url.split("\/");
				if (ruta.length >= 2 && ruta[2] != "") {
					this.loadSubModules(ruta[2]);
				}
				this.urlSubscription.unsubscribe();
			}
		});
		this.subscription = this.store.select('module').subscribe(module => this.loadSubModules(module.module));
	}

	ngOnInit() {
		// console.log('Init sidebar');
		// console.log(this.router.url);

	}
	ngOnDestroy() {
		this.subscription.unsubscribe();

	}
	loadSubModules(module: string) {
		if (module === null) {
			this.parentModule = null;
			this.subModules = [];
			// this.store.dispatch(new ActivarLoadingAction());
		} else {
			this.parentModule = this.homeLink + '/' + module;
			this.store.dispatch(new ActivarLoadingAction());
			this.systemService.getSubmodules(module).subscribe((data: any[]) => {
				if (data['success']) {
					this.subModules = [];
					data['data'].forEach(submodules => {
						submodules['mn_path'] = this.homeLink + submodules['mn_path'];
						this.subModules.push(submodules);
					});
					this.store.dispatch(new DesactivarLoadingAction());
				}
			});
		}

	}

}
